<template>

<van-tabs class="title-tabs-cable"   sticky v-model:active="StoreActiveChoiceCableWithTime"  animated shrink line-width="80">

  <van-tab   :disabled="StoreActiveChoiceCable != 0" :title-class="margeIfEgal(StoreActiveChoiceCable, 0 , 'fr' , 'en' , 'nl' , 'sv', 'it', 'fi' , 'de')" >
    <template #title> {{ $t('Nombre de Fibre') }}  
      <van-icon v-if="StoreActiveChoiceCable == 0"  @click="this.messageNbFibre = !this.messageNbFibre" disabled class="icon_info icon_info_cable" color="#1989fa"  name="info-o" />
   
    </template>
      <SelectNbFibre :messageNbFibre="this.messageNbFibre" @update-msg-nbfibre="updateMsgNbfibre" />
  </van-tab>

  <van-tab  :disabled="StoreActiveChoiceCable != 1" :title-class="margeIfEgal(StoreActiveChoiceCable, 1 , 'fr' )" >
    <template  #title>{{ $t('Type de fibre') }}
      <van-icon v-if="StoreActiveChoiceCable == 1 && $i18n.locale == 'fr'"  @click="messageTypeFibre" disabled class="icon_info icon_info_cable" color="#1989fa"  name="info-o" />
    </template>
    <SelectTypeFibre v-if="StoreActiveChoiceCable == 1" />
  </van-tab>

  <van-tab :disabled="StoreActiveChoiceCable != 2" :title-class="margeIfEgal(StoreActiveChoiceCable, 2 , 'fr' , 'en' , 'nl', 'sv', 'it' , 'fi' , 'de')" >
    <template #title>{{ $t('Structure de câble') }}
      <van-icon v-if="StoreActiveChoiceCable == 2 && $i18n.locale == 'fr'"  @click="messageStructureFibre" disabled class="icon_info icon_info_cable" color="#1989fa"  name="info-o" />
     </template>
    <SelectStructureFibre v-if="StoreActiveChoiceCable == 2" />
  </van-tab>


  <van-tab :disabled="StoreActiveChoiceCable != 3" :title-class="margeIfEgal(StoreActiveChoiceCable, 3 , 'fr' , 'en' , 'nl', 'sv', 'it', 'fi'  , 'de')" >
    <template #title>{{ $t('Euroclasse') }}
      <van-icon v-if="StoreActiveChoiceCable == 3 && $i18n.locale == 'fr'"  @click="messageEuroclassFibre" class="icon_info icon_info_cable" color="#1989fa"  name="info-o" />
    </template>
    <SelectEuroclassFibre v-if="StoreActiveChoiceCable == 3 && !StoreCodeRefStructureFamilleFibre.includes('PEHD') " />
    <SelectEuroclassFibreAuto v-if="StoreActiveChoiceCable == 3 && ( StoreCodeRefStructureFamilleFibre.includes('PEHD') || StoreCodeRefStructureFamilleFibre.includes('PUR') ) " />
  </van-tab>

     
  <span v-if="StorePkNbFibre && StorePkTypeFibre && StorePkStructureFibre && StorePkEuroclassFibre">
                <ShowCableRequest/>
  </span>


</van-tabs>


</template>
    
    
    <script>
    import SelectNbFibre from './SelectNbFibre.vue'
    import SelectTypeFibre from './SelectTypeFibre.vue'
    import SelectStructureFibre from './SelectStructureFibre.vue'
    import SelectEuroclassFibre from './SelectEuroclassFibre.vue'
    import SelectEuroclassFibreAuto from './SelectEuroclassFibreAuto.vue'
    import ShowCableRequest from './ShowCableRequest.vue'
    export default {
      components: {
        SelectNbFibre,
        SelectTypeFibre,
        SelectStructureFibre,
        SelectEuroclassFibre,
        SelectEuroclassFibreAuto,
        ShowCableRequest,
      },
      emits :{
          'updateMsgNbfibre': null
        },
      data() {
        return {
          messageNbFibre: false,
          showCable: false,
          showCoA: false,
          showCoB: false,
          showLong: false,
          StoreActiveChoiceCableWithTime: 0,
          imagesTypeFibre: [
          "https://admin-fibre.gigamedia.net/images/infos/mode_fibre_"+ this.$i18n.locale +".png"
          ] ,
          imagesStructure: [
          "https://admin-fibre.gigamedia.net/images/infos/structure_"+ this.$i18n.locale +".png"
          ] ,
          imagesEuroclass: [
          "https://admin-fibre.gigamedia.net/images/infos/euroclass_"+ this.$i18n.locale +".png"
        ] 
        }
      },
      watch: {
        // à chaque fois que la question change, cette fonction s'exécutera
        StoreActiveChoiceCable: function (data) {
          setTimeout(() => this.StoreActiveChoiceCableWithTime = data, 50);
          //setTimeout(this.testtest(data), 30000);

          },
        },
      computed: {
            /** Etape choix du cable */
            StoreActiveChoiceCable() {
              if( Object.keys(this.$store.state.storeCable.cable).length > 3 )
              {
                return 3
              }
              else{
                return Object.keys(this.$store.state.storeCable.cable).length
              }
                
            },
              /** Nombre de fibre */
              StorePkNbFibre() {
                return this.globalFunction.existKeyInArray("nombre", this.$store.state.storeCable.cable) 
                ? this.$store.state.storeCable.cable.nombre.pkNbFibre
                : null 
            },

          
             /** type de fibre */
             StorePkTypeFibre() {
              return this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable) 
                ? this.$store.state.storeCable.cable.type.pkTypeFibre
                : null 
            },
           
             /** Structure de fibre */
             StorePkStructureFibre() {
              return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) 
                ? this.$store.state.storeCable.cable.structure.pkStructureId
                : null 
            },

             StoreCodeRefStructureFamilleFibre() {
              return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) 
                ? this.$store.state.storeCable.cable.structure.codeRefStructureFamille
                : null 
            },


             /** Euroclass de cable */
             StorePkEuroclassFibre() {
              return this.globalFunction.existKeyInArray("euroclass", this.$store.state.storeCable.cable) 
                ? this.$store.state.storeCable.cable.euroclass.pkEuroclass
                : null 

            },


          },
      methods:{
        updateMsgNbfibre(e) {
          this.messageNbFibre= e
      },
        //MArge des tabs si actif
        margeIfEgal(value1 , value2 , langFr = 'no'  , langEn = 'no' , langNl = 'no' , langSv = 'no' , langIt = 'no' , langFi = 'no', langDe = 'no' ){
          if(value1 == value2 && ( langFr == this.$i18n.locale 
          || langEn == this.$i18n.locale 
          || langNl == this.$i18n.locale 
          || langSv == this.$i18n.locale 
          || langIt == this.$i18n.locale 
          || langFi == this.$i18n.locale 
          || langDe == this.$i18n.locale 
          ) ){
            return 'm-r4'
          }else{
            return ''
          }
        },
           //mesage structure cable
           messageStructureFibre(){
        this.$viewerApi({
          options: {
            title: false,
            navbar: false,
          },
        images: this.imagesStructure,
      })
      },
      messageEuroclassFibre(){
       this.$viewerApi({
        options: {
            title: false,
            navbar: false,
          },
               images: this.imagesEuroclass,
             })
           
     
           },
           messageTypeFibre(){
       this.$viewerApi({
        options: {
            title: false,
            navbar: false,
          },
               images: this.imagesTypeFibre,
             })
           
     
           },
          }
    
   
    
    }

    </script>

    <style>
 
  </style>